<template>
  <v-layout
    row
    justify-center
    align-center
    class="authenticator-container"
  >
    <v-card
      min-width="460"
      class="px-4 py-4"
    >
      <v-card-title>
        <h2>Confirm Sign Up</h2>
      </v-card-title>

      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
        >
          <v-select
            v-if="!isCognitoType"
            v-model="appId"
            :items="applications"
            :rules="[v => !!v || 'Application client ID is required']"
            label="Application client ID "
            required
          />

          <v-text-field
            v-model="email"
            :rules="emailRules"
            label="Email"
            required
          />

          <v-text-field
            v-model="code"
            :rules="codeRules"
            label="Confirmation Code"
            required
          />

          <div class="mt-2">
            Lost your code? <a
              v-if="!isResend"
              href="JavaScript:void(0);"
              @click="resend"
            >Resend Code</a>
          </div>

          <v-layout
            row
            justify-space-between
            align-center
            class="mt-2"
          >
            <div>
              Have an account?
              <router-link
                :to="{ path: '/login', query: isCognitoType ? { type: 'cognito'} : null }"
              >
                Back to Sign In
              </router-link>
            </div>
            <e-button
              color="primary"
              text="Confirm"
              :loading="loading"
              :disabled="!valid || isSubmit"
              @click="submit"
            />
          </v-layout>
        </v-form>

        <v-alert
          v-if="error"
          type="error"
          :value="true"
          class="mt-2"
        >
          {{ error }}
        </v-alert>
      </v-card-text>
    </v-card>
  </v-layout>
</template>

<script>
import { confirmSignUp, resendSignUp } from '@/utils/auth';
import { Button } from '@/components/shared';

export default {
  name: 'SignUpConfirm',
  components: {
    'e-button': Button,
  },
  data() {
    return {
      valid: false,
      isSubmit: false,
      isResend: false,
      isCognitoType: false,
      email: '',
      code: '',
      error: '',
      appId: '1',
      applications: [
        { text: 'Exporo AG', value: '1' },
        { text: 'Accontis', value: '4' },
      ],
    };
  },
  computed: {
    emailRules() {
      return [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid',
      ];
    },
    codeRules() {
      return [
        v => !!v || 'Code is required',
        v => (v && v.length === 6) || 'Code must be 6 digits',
      ];
    },
  },
  watch: {
    $route(to) {
      this.error = '';
      this.checkLoginType(to.query);
    },
  },
  created() {
    this.checkLoginType(this.$route.query);
  },
  methods: {
    async submit() {
      this.error = '';

      if (this.$refs.form.validate()) {
        const username = this.concatUsername(this.appId, this.email);

        try {
          this.isSubmit = true;
          await confirmSignUp(username, this.code);
          this.isSubmit = false;
        } catch (err) {
          this.setError(err);
          this.isSubmit = false;
        }
      }
    },
    async resend() {
      this.error = '';

      if (!this.email) {
        this.setError('To resend code, you need to fill email field');

        return;
      }

      const username = this.concatUsername(this.appId, this.email);

      try {
        this.isResend = true;
        await resendSignUp(username);
        this.isResend = false;
      } catch (err) {
        this.setError(err);
        this.isResend = false;
      }
    },
    concatUsername(appId, email) {
      if (this.isCognitoType) {
        return email;
      }

      return `${email}_app_${appId}`;
    },
    setError(err) {
      this.error = err.message || err;
    },
    checkLoginType(query) {
      const { type } = query;
      this.isCognitoType = type === 'cognito';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/authenticator/SignUpConfirm.vue